<template>
  <div id="TripsDashboard">
    <v-container fluid>
      <v-row>
        <v-col class=" right-border" cols="4">
          <div>
            <v-card flat style="height: calc(100vh - 120px); overflow-y: auto">
              <v-card-text>
                <v-row>
                  <v-col class="pa-0 mb-5" cols="12">
                    <div class="d-flex justify-sm-start">
                      <h2 class="font-weight-medium text-h6">Trips ({{ trips.length }})</h2>
                      <v-btn icon @click="startCreateTrip" class="grey lighten-3 text--primary  elevation-0 ml-2">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-menu :close-on-content-click="false" max-width="290px" min-width="290px" offset-y
                              ref="dateFilterMenu" transition="scale-transition" v-model="dateFilterMenu">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field style="max-width: 170px !important;" dense flat hide-details label="Filter Date"
                                        outlined prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                                        v-model="filterFormattedDate" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker @input="dateFilterMenu = false" no-title v-model="filterDate"></v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pa-0 ma-0 mb-3">
                    <v-text-field dense flat hide-details clearable label="Search" outlined
                                  @input="searchTrip"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pa-0">
                    <v-list flat>
                      <v-list-item-group color="primary">
                        <v-card
                            :class="trip.id===selectedTrip.id?'blue lighten-5 mb-4 elevation-0':'mb-4 '+' elevation-0'"
                            :key="index" @click="getTripDashboard(trip)" v-for="(trip,index) in filteredTrips">
                          <v-list-item-content class="px-5">
                            <div class="d-flex align-center">
                              <h3 class="mb-2">{{ trip.tripId ? trip.tripId : '-' }}</h3>
                              <v-spacer></v-spacer>
                              <div class="mb-3">
                                <v-btn :color="getStatusColor(trip.statusId)" outlined x-small>
                                  {{ trip.TripStatus.title }}
                                </v-btn>
                              </div>
                            </div>
                            <v-row align="center">
                              <v-col class="pb-0" cols="4">
                                <div class="text-center">
                                  <v-icon size="20" class="mb-1 mt-3">mdi-account-outline</v-icon>
                                  <span class="text-caption grey--text text--darken-2 d-block ">{{trip.Driver&&trip.Driver.name }}</span>
                                </div>
                              </v-col>
                              <v-col class="pb-0" cols="4">
                                <div class="text-center">
                                  <v-icon size="20" class="mb-1 mt-3">mdi-truck-outline</v-icon>
                                  <span class="text-caption grey--text text--darken-2 d-block ">{{
                                      trip.Vehicle.platNo
                                    }}</span>
                                </div>
                              </v-col>
                              <v-col class="pb-0" cols="4">
                                <div class="text-center">
                                  <v-icon size="20" class="mb-1 mt-3">mdi-map-marker-outline</v-icon>
                                  <span class="text-caption grey--text text--darken-2 d-block ">{{trip.Route&&trip.Route.name }}</span>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                          <v-divider></v-divider>
                        </v-card>
                      </v-list-item-group>
                    </v-list>
                    <v-expansion-panels v-if="notLoadedTrips.length">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Previous Remaining Trips ({{ notLoadedTrips.length }})
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-list flat>
                            <v-list-item-group color="primary">
                              <v-card class="px-5"
                                      :class="trip.id===selectedTrip.id?'blue lighten-5 elevation-0':''+' elevation-0'"
                                      :key="index" @click="getTripDashboard(trip)"
                                      v-for="(trip,index) in filteredNotLoadedTrips">
                                <v-list-item-content>
                                  <div class="d-flex align-center">
                                    <span class="text-overline font-weight-bold grey--text text--darken-1">{{
                                        dateFormat(trip.created_at)
                                      }}</span>
                                    <v-spacer></v-spacer>
                                    <v-btn class="ma-0 pa-1" :color="getStatusColor(trip.statusId)" outlined x-small>
                                      {{ trip.TripStatus.title }}
                                    </v-btn>
                                  </div>
                                  <h4 class="mb-1">{{ trip.tripId ? trip.tripId : '-' }}</h4>

                                  <v-row>
                                    <v-col class="pb-0" cols="4">
                                      <div class="text-center">
                                        <v-icon size="20" class="mb-1 mt-3">mdi-account-outline</v-icon>
                                        <span class="text-caption grey--text text--darken-2 d-block ">{{trip.Driver&&trip.Driver.name }}</span>
                                      </div>
                                    </v-col>
                                    <v-col class="pb-0" cols="4">
                                      <div class="text-center">
                                        <v-icon size="20" class="mb-1 mt-3">mdi-truck-outline</v-icon>
                                        <span class="text-caption grey--text text--darken-2 d-block ">{{trip.Vehicle&&trip.Vehicle.platNo }}</span>
                                      </div>
                                    </v-col>
                                    <v-col class="pb-0" cols="4">
                                      <div class="text-center">
                                        <v-icon size="20" class="mb-1 mt-3">mdi-map-marker-outline</v-icon>
                                        <span class="text-caption grey--text text--darken-2 d-block ">{{trip.Route&&trip.Route.name }}</span>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-list-item-content>
                                <v-divider></v-divider>
                              </v-card>
                            </v-list-item-group>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
        <v-col cols="8">
          <TripWidgets v-if="mode==='SUMMARY_DASHBOARD'"></TripWidgets>
          <TripDashboard :tripId="selectedTrip.id" v-else-if="mode==='SINGLE_DASHBOARD'"></TripDashboard>
        </v-col>
      </v-row>
    </v-container>
    <CreateUpdateTrip :tripDialog="tripDialog" @cancel="tripDialog=false" @saveTrip="saveTrip"
                      v-if="tripDialog"></CreateUpdateTrip>
  </div>
</template>

<script>
import CreateUpdateTrip from '../../components/TripManagement/CreateUpdateTrip'
import { SUBSCRIBE_ALL_TRIPS, SUBSCRIBE_NOT_UNLOADED_TRIPS } from '../../graphql/subscriptions/Trips'
import moment from 'moment'
import TripDashboard from '../../components/TripManagement/TripDashboard'
import TripWidgets from '../../components/TripManagement/TripWidgets'
import {IDS} from "../../Constants/IDS";

export default {
  name: 'TripsDashboard',
  components: { TripWidgets, TripDashboard, CreateUpdateTrip },
  data () {
    return {
      dateFilterMenu: false, tripDialog: false, IDS,
      selectedTrip: {}, trips: [], notLoadedTrips: [],
      filteredTrips: [], filteredNotLoadedTrips: [],
      mode: 'SUMMARY_DASHBOARD',//SUMMARY_DASHBOARD/SINGLE_DASHBOARD
      filterDate: moment().format('YYYY-MM-DD'),
      toaster: { enable: false, color: 'green', message: '' },
      loggedInUser: JSON.parse(localStorage.user),
    }
  },
  apollo: {
    $subscribe: {
      Trips: {
        query: SUBSCRIBE_ALL_TRIPS, fetchPolicy: 'network-only',
        skip () { return !this.loggedInUser },
        variables () {
          return {
            startDate: this.filterDate,
            endDate: moment(this.filterDate, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD'),
            orgId: this.loggedInUser.organizationId,
          }
        },
        result ({ data, loading }) {
          if (!loading) {
            this.trips = data.Trips
            this.filteredTrips = data.Trips
            this.getTripDashboard(data.Trips.length ? data.Trips[0] : {})
          }
        },
      },
      NotLoadedTrips: {
        query: SUBSCRIBE_NOT_UNLOADED_TRIPS, fetchPolicy: 'network-only',
        skip () { return !this.loggedInUser },
        variables () { return { startDate: this.filterDate, orgId: this.loggedInUser.organizationId } },
        result ({ data, loading }) {
          if (!loading) {
            this.notLoadedTrips = data.NotLoadedTrips
            this.filteredNotLoadedTrips = data.NotLoadedTrips
          }
        },
      },
    },
  },
  computed: {
    filterFormattedDate () {
      return this.filterDate ? moment(this.filterDate).format('DD-MM-YYYY') : '-'
    },
  },
  methods: {
    startCreateTrip () {
      this.tripDialog = true
    },
    getTripDashboard (trip) {
      this.selectedTrip = trip
      // eslint-disable-next-line no-prototype-builtins
      if (this.selectedTrip.hasOwnProperty('id')) {
        this.mode = 'SINGLE_DASHBOARD'
      } else {
        this.mode = 'SUMMARY_DASHBOARD'
      }
      this.$forceUpdate()
    },
    getStatusColor (statusId) {
      if (statusId === IDS.TripStatus.Unloaded || statusId === IDS.TripStatus.UnloadedWithOpening)
        return 'green'
      if (statusId === IDS.TripStatus.Completed)
        return 'grey'
      else if (statusId === IDS.TripStatus.InProgress)
        return 'orange'
      else if (statusId === IDS.TripStatus.NotStarted)
        return 'red'
      else return 'unset'
    },
    saveTrip () {
      this.toaster = {
        enable: true, color: 'green',
        message: `Trip ${this.selectedTrip ? 'updated' : 'created'} successfully`,
      }
      this.tripDialog = false
    },
    searchTrip (val) {
      if (val) {
        this.filteredTrips = this.trips.filter(trip => {
          val = val.toString().toLowerCase()
          return trip.tripId.toString().toLowerCase().includes(val) ||
              trip.Driver.name.toString().toLowerCase().includes(val) ||
              trip.Route.name.toString().toLowerCase().includes(val) ||
              trip.Vehicle.platNo.toString().toLowerCase().includes(val)
        })
        this.filteredNotLoadedTrips = this.notLoadedTrips.filter(trip => {
          val = val.toString().toLowerCase()
          return trip.tripId.toString().toLowerCase().includes(val) ||
              trip.Driver.name.toString().toLowerCase().includes(val) ||
              trip.Route.name.toString().toLowerCase().includes(val) ||
              trip.Vehicle.platNo.toString().toLowerCase().includes(val)
        })
      } else {
        this.filteredTrips = this.trips
        this.filteredNotLoadedTrips = this.notLoadedTrips
      }
    },
    dateFormat (val) {
      return val ? moment(val).format('DD MMM YYYY') : ''
    },
  },
}
</script>

<style scoped>
.v-list {
  padding: 0;
}

@media (min-width: 1904px) {
  /deep/ .container {
    max-width: 1385px !important;
  }
}

/deep/ .v-expansion-panel-content__wrap {
  padding: 0px !important;
}

/deep/ .v-expansion-panel-header {

}

/*/deep/.arrow{*/
/*  color: #fff !important;*/
/*}*/
/*/deep/.arrow:after{*/
/*  content: "";*/
/*  border-right: solid 12px white;*/
/*  border-bottom: solid 8px transparent;*/
/*  border-top: solid 8px transparent;*/
/*  position: absolute;*/
/*  right: 0px;*/

/*}*/
.right-border {
  border-right: 1px solid lightgrey;
}
</style>
